import {Button, Card, Dropdown, SplitButton} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import {INBOX_MESSAGES as M, MAIL_HEADERS} from '../inboxMessages'
import ReactQuill from 'react-quill'
import {useState} from 'react'
import 'react-quill/dist/quill.snow.css'
import {GmailEmail} from './InitInboxContent'

function parseSenderName(fromEmail: string): string {
  const match = fromEmail.match(/^(.+?)\s*</)
  return match ? match[1].trim() : fromEmail
}

function parseSenderAddress(fromEmail: string): string {
  const match = fromEmail.match(/<(.+?)>/)
  return match ? match[1] : fromEmail
}

function senderInitial(fromEmail: string): string {
  return parseSenderName(fromEmail).charAt(0).toUpperCase() || '?'
}

interface IOneMsg {
  infoMsg: GmailEmail
  ButtonMenu: JSX.Element
  onBack: () => void
}

export const OneMessage: React.FC<IOneMsg> = ({infoMsg, ButtonMenu, onBack}) => {
  const intl = useIntl()
  const [value, setValue] = useState('')
  return (
    <>
      <Card.Header>
        <div className='card-title justify-content-between w-100 flex-wrap'>
          <div className='d-flex align-items-center gap-2'>
            <Button variant='link' onClick={onBack}>
              <i className='p-0 bi bi-arrow-left' />
            </Button>
            <Button variant='secondary' size='sm' className='d-flex flex-center px-3 py-2'>
              <i className='p-0 bi bi-envelope fs-6' style={{color: 'inherit'}} />
            </Button>
            <Button variant='secondary' size='sm' className='d-flex flex-center px-3 py-2'>
              <i className='p-0 bi bi-patch-exclamation fs-6' style={{color: 'inherit'}} />
            </Button>
            <Button variant='secondary' size='sm' className='d-flex flex-center px-3 py-2'>
              <i className='p-0 bi bi-trash-fill fs-6' style={{color: 'inherit'}} />
            </Button>
          </div>
          <div>
            <div className='d-flex align-items-center'>
              <div className='d-flex algin-items-center'>
                <Button size='sm' className='ms-2 px-2 py-1 flex flex-center' variant='secondary'>
                  <i className='p-0 bi bi-chevron-left' />
                </Button>
                <Button size='sm' className='ms-2 px-2 py-1 flex flex-center' variant='secondary'>
                  <i className='p-0 bi bi-chevron-right' />
                </Button>
                {ButtonMenu}
              </div>
            </div>
          </div>
        </div>
      </Card.Header>
      <Card.Body>
        <Card.Title>{infoMsg.subject || intl.formatMessage(M.noSubject)}</Card.Title>
        <div className='d-flex align-items-center flex-grow-1'>
          <div
            className='symbol-label bg-primary text-white fw-bold fs-4 me-5'
            style={{
              width: 45,
              height: 45,
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            {senderInitial(infoMsg.fromEmail)}
          </div>
          <div className='d-flex flex-column'>
            <div className='d-flex align-items-center gap-2'>
              <span className='text-gray-800 text-hover-primary fs-6 fw-bold'>
                {parseSenderName(infoMsg.fromEmail)}
              </span>
            </div>
            <span className='text-gray-400 fw-semibold'>{parseSenderAddress(infoMsg.fromEmail)}</span>
          </div>
        </div>
        <div className='mt-6 d-flex align-items-center flex-wrap gap-2'>
          <span className='fw-semibold text-muted text-end me-3'>{infoMsg.date}</span>
        </div>
        <div className='py-5'>
          <p className='text-muted'>{infoMsg.snippet}</p>
        </div>
      </Card.Body>
      <Card.Footer>
        <div className='d-flex align-items-center border-bottom px-8 min-h-50px'>
          {MAIL_HEADERS.to}
          <div className='ms-2 text-muted'>{parseSenderAddress(infoMsg.fromEmail)}</div>
        </div>
        <div className='d-flex align-items-center border-bottom px-8 min-h-50px'>
          <input
            type='text'
            placeholder={intl.formatMessage(M.subjectPlaceholder)}
            className='w-100 h-100'
            style={{border: 0}}
          />
        </div>
        <ReactQuill
          theme='snow'
          value={value}
          onChange={setValue}
          className='w-100'
          style={{border: 0}}
        />
        <div className='d-flex align-items-center justify-content-between mt-3'>
          <div className='d-flex align-items-center gap-4'>
            <SplitButton
              id='dropdown-reply'
              variant='primary'
              title={intl.formatMessage(M.reply)}
            >
              <Dropdown.Item eventKey='1'>{intl.formatMessage(M.replyAll)}</Dropdown.Item>
              <Dropdown.Item eventKey='2'>{intl.formatMessage(M.forward)}</Dropdown.Item>
            </SplitButton>
            <button style={{backgroundColor: 'transparent', border: 0}}>
              <i className='bi bi-paperclip fs-2' />
            </button>
          </div>
          <div>
            <button style={{backgroundColor: 'transparent', border: 0}}>
              <i className='bi bi-trash fs-2' />
            </button>
          </div>
        </div>
      </Card.Footer>
    </>
  )
}
